module.exports = __webpack_public_path__ + "static/toggl-global-main-e3c046ca53884d8fc5aec0799dd267b0.jpg";